import React from "react";

const WhereCanIFind = (props: any) => {
    return (
        <div>
            <p>
                The FTC has helpful information on their website:{" "}
                <a target="_blank" href="https://www.consumer.ftc.gov/articles/0040-child-identity-theft" rel="noreferrer">
                    https://www.consumer.ftc.gov/articles/0040-child-identity-theft
                </a>
            </p>
        </div>
    );
};

export default WhereCanIFind;
